export enum CustomsPurposeEnum {
    SOLD = 'SOLD',
    NOT_SOLD = 'NOT_SOLD',
    GIFT = 'GIFT',
    PERSONAL_EFFECTS = 'PERSONAL_EFFECTS',
    REPAIR_AND_RETURN = 'REPAIR_AND_RETURN',
    SAMPLE = 'SAMPLE'
}
